import { app } from '../../../../../../app';

app.component('confirmConvert', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    templateUrl: require('./confirm-convert.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-authenticators/manage/confirm-convert/confirm-convert.component.js